import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Provider } from 'react-redux'

import Layout from './components/Layout'
import siteMaps from './site-maps'
import Home from './components/Home'
import Reset from './components/Reset'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/reset" element={<Reset />} />
          {siteMaps.map((item) => (
            <Route
              key={item.id}
              path={`/${item.path}/:code?`}
              element={item.component}
            />
          ))}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
